import { useEffect, useState } from 'react'
import { LogOut, Menu, Settings, Wallet } from 'lucide-react'
import { Dropdown } from 'antd'
import RoutesMap from 'route_control/RouteControl'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { customerDetails } from '../../redux/slices/dashboard'
import { signOut } from '../../redux/slices/assets'
import { getUser } from 'utils'
import { useTranslation } from 'react-i18next'

export default function Header(props) {

    const { collapsed, setCollapsed, drawerOpen, setDrawerOpen, isMobileOrTablet } = props
    const [date] = useState(new Date().toDateString())
    const { t } = useTranslation()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const details = useSelector(state => state?.dashboard?.details)

    // Portal shows "Hi, {firstName}" — fall back to username when firstName is empty
    const display_name = details?.firstName || details?.userName || getUser()?.userName || ''

    // Portal: "Current wallet balance" = abs(outStanding) from getBasicCustomerDetails
    const wallet = Math.abs(details?.outStanding || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

    useEffect(() => {
        if (!details) dispatch(customerDetails({ navigate }))
    }, [])

    // Portal gear menu contains only "Log Out"
    const user_option = {
        items: [
            { key: 'logout', label: t('common.logout'), icon: <LogOut size={14} />, danger: true },
        ],
        onClick: ({ key }) => {
            if (key === 'logout') dispatch(signOut()).then(() => navigate(RoutesMap.LOGIN.path))
        },
    };

    return (
        <>
            <nav className={`navbar fixed-top ${isMobileOrTablet ? 'navbar_mobile_view' : collapsed ? "navbar_body_collapsed" : "navbar_body_notcollapsed"}`} >
                <div className="container-fluid">
                    <span className="navbar-brand d-flex align-items-center">
                        <Menu size={20} onClick={() => isMobileOrTablet ? setDrawerOpen(!drawerOpen) : setCollapsed(!collapsed)} style={{ cursor: 'pointer' }} />
                        <span className='d-flex flex-column ms-3'>
                            <span style={{ fontSize: '13px' }} className="fw-bold">{t('common.hi')}, {display_name}</span>
                            <span style={{ fontSize: '11px' }} className='text-secondary'>{date}</span>
                        </span>
                    </span>

                    <div className='d-flex align-items-center header-actions'>

                        <span className='header_wallet d-flex align-items-center gap-2'>
                            <Wallet size={16} />
                            <span className='d-none d-sm-inline'>{t('common.wallet_balance')}</span>
                            <b>₹{wallet}</b>
                        </span>

                        {/* <span>|</span>

                        <Dropdown menu={user_option} placement="bottomRight" trigger={['click']}>
                            <Settings size={18} style={{ cursor: 'pointer' }} aria-label="settings" />
                        </Dropdown> */}
                    </div>
                </div>
            </nav>
        </>
    )
}
